module.exports = __webpack_public_path__ + "img/jiantou.6baf4d80.png";